import '@bsds-lib-component/core/css/bsc.css'
import '@bsds-lib-component/core/css/web.css'
import '@bsds-lib-component/core/dist/bsds-lib-component/bsds-lib-component.css'
import { BsdsApp, setupBsdsLibComponentReact } from '@bsds-lib-component/react'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import './index.css'

import App from './App'

setupBsdsLibComponentReact()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BsdsApp>
      <App />
    </BsdsApp>
  </StrictMode>,
)

